export enum CustomPageTypes {
  PAGE = 'page',
  HOMEPAGE = 'homepage',
  LANDINGPAGE = 'landingpage',
}

export const TABLE_HEADER = {
  pageName: 'Page Name',
  id: 'ID',
  prismicLink: 'Prismic Link',
  status: 'AB Test Status',
  seo: 'SEO Status',
  updated: 'Last Updated',
  viewable: 'Viewable',
};

export const MODULE_ACTION = {
  orderAmount: 'Order amount',
  customerTag: 'Customer tags',
  reset: 'Reset',
  tips: 'add tags one by one or separate them by a coma',
  apply: 'Apply',
};
